import './headerandvalue.scss';

interface HeaderAndTextProps {
	align?: 'left' | 'right';
  header: string;
  value: string | JSX.Element | JSX.Element[];
	hideOverflow?: boolean;
}

const HeaderAndValue = ({
	align = 'left',
	header,
	value,
	hideOverflow = false,
}: HeaderAndTextProps) => {

	return (
		<div className="header-and-value-container">
			<div className="header" style={{
				textAlign: align,
			}}>
				{header}
			</div>
			<div className="value" style={{
				textAlign: align,
			}}>
				{value}
			</div>
		</div>
	);
}

export default HeaderAndValue;